import React from 'react';
import {
  createOptionsList,
  createOptionsListFromArray,
  createYesNoOptionsList,
} from '../../../services/common/miscUtils';
import { getMaxBirthDate, getMinBirthDate } from '../../../services/common/validation';
import {
  CcrTypeEnum,
  CorrespondenceMethodEnum,
  CountryCodeEnum,
  GenderEnum,
  MaritalStatusEnum,
  TelephoneTypeEnum,
  TitleEnum,
} from '../../../types/forms';
import { NationalityEnum } from '../../../types/nationality';
import { DatePickerFormField } from '../../Fieldset/DatePickerFormField';
import { PhoneNumberFormField } from '../../Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';

export const createFormInputs = (formTranslationKey: string) => {
  return {
    title: () => (
      <SelectFormField
        fieldName="title"
        labelTranslationKey={`${formTranslationKey}:fields:title:label`}
        optionList={createOptionsList(TitleEnum, formTranslationKey, 'title')}
      />
    ),
    gender: () => (
      <SelectFormField
        fieldName="gender"
        labelTranslationKey={`${formTranslationKey}:fields:gender:label`}
        optionList={createOptionsList(GenderEnum, formTranslationKey, 'gender')}
      />
    ),
    maritalStatus: () => (
      <SelectFormField
        fieldName="maritalStatus"
        labelTranslationKey={`${formTranslationKey}:fields:maritalStatus:label`}
        optionList={createOptionsList(MaritalStatusEnum, formTranslationKey, 'maritalStatus')}
      />
    ),
    makeIndemnifier: () => (
      <SelectFormField
        fieldName="makeIndemnifier"
        labelTranslationKey={`${formTranslationKey}:fields:makeIndemnifier:label`}
        optionList={createYesNoOptionsList(formTranslationKey, 'makeIndemnifier')}
      />
    ),
    firstName: () => (
      <TextInputFormField
        fieldName="firstName"
        labelTranslationKey={`${formTranslationKey}:fields:firstName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:firstName:placeholder`}
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName="lastName"
        labelTranslationKey={`${formTranslationKey}:fields:lastName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:lastName:placeholder`}
      />
    ),
    middleName: () => (
      <TextInputFormField
        fieldName="middleName"
        labelTranslationKey={`${formTranslationKey}:fields:middleName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:middleName:placeholder`}
        optional
      />
    ),
    maidenName: (isFemale: boolean, isOrWasMarried: boolean) => (
      <TextInputFormField
        fieldName="maidenName"
        labelTranslationKey={`${formTranslationKey}:fields:maidenName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:maidenName:placeholder`}
        optional={!isFemale || !isOrWasMarried}
      />
    ),
    dateOfBirth: () => (
      <DatePickerFormField
        fieldName="dateOfBirth"
        labelTranslationKey={`${formTranslationKey}:fields:dateOfBirth:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:dateOfBirth:placeholder`}
        maxDate={getMaxBirthDate()}
        minDate={getMinBirthDate()}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName="email"
        labelTranslationKey={`${formTranslationKey}:fields:email:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:email:placeholder`}
        validateOnChange
      />
    ),
    telephoneType: () => (
      <SelectFormField
        fieldName="telephoneType"
        labelTranslationKey={`${formTranslationKey}:fields:telephoneType:label`}
        optionList={createOptionsList(TelephoneTypeEnum, formTranslationKey, 'telephoneType')}
      />
    ),
    phoneNumber: (selectedMobileTelephoneType: boolean) => {
      return selectedMobileTelephoneType ? (
        <PhoneNumberFormField
          fieldName="phoneNumber"
          labelTranslationKey={`${formTranslationKey}:fields:mobileNumber:label`}
          placeholderTranslationKey={`${formTranslationKey}:fields:mobileNumber:placeholder`}
          type="mobile"
        />
      ) : (
        <PhoneNumberFormField
          fieldName="phoneNumber"
          labelTranslationKey={`${formTranslationKey}:fields:telephoneNumber:label`}
          placeholderTranslationKey={`${formTranslationKey}:fields:telephoneNumber:placeholder`}
          type="landline"
        />
      );
    },
    countryCode: () => (
      <SelectFormField
        fieldName="countryCode"
        labelTranslationKey={`${formTranslationKey}:fields:countryCode:label`}
        optionList={createOptionsList(CountryCodeEnum, formTranslationKey, 'countryCode')}
      />
    ),
    correspondenceMethod: () => (
      <SelectFormField
        fieldName="correspondenceMethod"
        labelTranslationKey={`${formTranslationKey}:fields:correspondenceMethod:label`}
        optionList={createOptionsList(CorrespondenceMethodEnum, formTranslationKey, 'correspondenceMethod')}
      />
    ),
    ccrType: () => (
      <SelectFormField
        fieldName="ccrType"
        labelTranslationKey={`${formTranslationKey}:fields:ccrType:label`}
        optionList={createOptionsList(CcrTypeEnum, formTranslationKey, 'ccrType')}
      />
    ),
    ccrId: () => (
      <TextInputFormField
        fieldName="ccrId"
        labelTranslationKey={`${formTranslationKey}:fields:ccrId:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:ccrId:placeholder`}
      />
    ),
    nationality: () => (
      <SelectFormField
        fieldName="nationality"
        labelTranslationKey={`${formTranslationKey}:fields:nationality:label`}
        optionList={createOptionsListFromArray(Object.keys(NationalityEnum))}
      />
    ),
  };
};
